import { render, staticRenderFns } from "./EmEmAdmUserGroupEdit.vue?vue&type=template&id=1139161e&"
import script from "./EmEmAdmUserGroupEdit.vue?vue&type=script&lang=js&"
export * from "./EmEmAdmUserGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports